import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.Boolean
import kotlin.String
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface PlaceSearchControllerTargetLifecycleHooks {
  public fun searchTargetConnected(element: HTMLElement) {
  }

  public fun searchTargetDisconnected(element: HTMLElement) {
  }

  public fun placeIdTargetConnected(element: HTMLElement) {
  }

  public fun placeIdTargetDisconnected(element: HTMLElement) {
  }

  public fun resultsTargetConnected(element: HTMLElement) {
  }

  public fun resultsTargetDisconnected(element: HTMLElement) {
  }

  public fun searchUrlValueChanged(`value`: String, previousValue: String) {
  }
}

public fun <T : HTMLElement> PlaceSearchController.searchTarget(): StimulusProperty<T> =
    StimulusProperty("searchTarget")

public fun <T : HTMLElement> PlaceSearchController.searchTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("searchTargets")

public fun <T : HTMLElement> PlaceSearchController.placeIdTarget(): StimulusProperty<T> =
    StimulusProperty("placeIdTarget")

public fun <T : HTMLElement> PlaceSearchController.placeIdTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("placeIdTargets")

public fun <T : HTMLElement> PlaceSearchController.resultsTarget(): StimulusProperty<T> =
    StimulusProperty("resultsTarget")

public fun <T : HTMLElement> PlaceSearchController.resultsTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("resultsTargets")

public fun PlaceSearchController.searchUrlValue(): StimulusProperty<String> =
    StimulusProperty("searchUrlValue")

public fun PlaceSearchController.hasSearchUrlValue(): Boolean {
  println(this.asDynamic()["hasSearchUrlValue"])
  return this.asDynamic()["hasSearchUrlValue"]
}

public fun registerPlaceSearchController(stimulus: Application) {
               val clazz = PlaceSearchController::class
               val properties = object  {
                  // Js name needed otherwise Kotlin will mangle the name
                  @JsName("targets")
                  val targets = js("""[
  "search",
  "placeId",
  "results",
  ]""")

                  @JsName("values")
                  val values = buildValues(
                      setOf(
                          ValueDefinition("searchUrl", "String", false)
                      ),
                      PlaceSearchController.Values
                  )
                  
                  
                  
                  @JsName("classes")
                  val classes = js("[]")
              }

              val factoryFunc = clazz.js.asDynamic()

              addStaticMembersTo(factoryFunc, properties)
              val controllerName = "placesearch"
              println("Registering controller placesearch")

              stimulus.register(controllerName, factoryFunc)
}
